<template>
  <div>
    <div class="row">
        <div class="col-12 col-xs-6 col-md-6">
        <div class="panel" v-if="shop">
          <div class="panel-heading">
            <div class="panel-label">
              <h3>Shop information</h3>
            </div>
            <div class="panel-toolbar">
              <shop-devices :context="id" :reloadData="loadData"></shop-devices>
              <router-link
                tag="button"
                class="btn btn-danger btn-sm"
                :to="`${id}/${$TYPES.ROUTES.EDIT}`"
              >Edit Shop</router-link>
            </div>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-12">
                <div class="shop-title">
                  <div class="image-title">
                    <img class="shopimage" :src="shop.iconURL" />
                  </div>
                  <div class="text-title">
                    <h3>
                      {{shop.name}}
                    </h3>
                      <small v-if="shop.externalID">External: {{shop.externalID}}</small>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-xs-12 col-lg-6">
                <table class="table shopinfo">
                  <tbody>
                    <tr v-for="(v, k) in shop.address" :key="k">
                      <th>{{k}}</th>
                      <td>{{v}}</td>

                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xs-12 col-lg-6">
                <show-map :shops="shop"></show-map>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="col-12 col-xs-6 col-md-6">
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-label">
                    <h3>Shop QR codes - printer:</h3>
                </div>
                <div class="panel-toolbar">
                    QR
                </div>
            </div>
            <div class="panel-body">
                <div class="qr-box">
                    <canvas id="new" ref="new"></canvas>
                </div>
            </div>
            <div class="panel-footer">
                <button @click="downloadCode(showBox, shop)" class="btn btn-info btn-sm">Download Code</button>
                <a ref="downloadLink"></a>
            </div>
        </div>
    </div>

    </div>
    <products-table v-if="shop" :id="shop.id" :per-page="5"></products-table>
    <shop-cubes v-if="shop" :shopid="shop.id"></shop-cubes>


    <div class="panel mb-3">

        <div class="panel-heading" @click="shopOwnerPanel = !shopOwnerPanel">
            <div class="pass-header panel-label row w-100">
                <div class="col-8">
                    <h3>Add/Change Shop Owner Password</h3>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end">
                    <span class="passArrow" :class="{'active':shopOwner}">
                        <i v-if="shopOwnerPanel" class="el-icon-arrow-up"></i>
                        <i v-else class="el-icon-arrow-down"></i>
                    </span>
                </div>
            </div>

            <div class="panel-toolbar">
            </div>
        </div>

        <div v-if="shopOwnerPanel">
            <div class="panel-body d-flex justify-content-start flex-column">
              <el-form autocomplete="off">
                <label>Email</label>
                <el-input class="mb-2" placeholder="Email" v-model="email" :disabled="shopOwner"></el-input>

                <label>Password</label>
                <el-input class="mb-2" autocomplete="new-password" placeholder="Password" v-model="shopOwnerPass" show-password></el-input>

                <label>Repeat password</label>
                <el-input autocomplete="new-password"  placeholder="Repeat password" v-model="shopOwnerPassRepeat" show-password></el-input>
              </el-form>
            </div>

            <div class="panel-footer">
                <button class="btn btn-success" @click="setShopOwner">OK</button>
                <button class="btn btn-danger ml-2" @click="deleteSHopOwner(shopOwnerData)" v-if="shopOwner">Delete</button>
            </div>
        </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Map from '../../../components/Panel/Geo/MapComponent.vue';
import ShopCubes from '../../../components/Panel/Shops/ShopCubes.vue';
import ProductsTable from '../Products/ProductsTable.vue';
import ShopDevices from './ShopDevices.vue';
import axios from 'axios';
import Vue from 'vue';

import QRCode from 'qrcode';
export default {
    name: 'shops',
    data () {
        return {
            shop: undefined,
            setup: {},
            setups: [{ qr: 'new', name: 'new QR' }],
            showBox: 'new',
            shopOwner: false,
            shopOwnerData: '',
            shopOwnerPass: '',
            shopOwnerPassRepeat: '',
            shopOwnerPanel: false,
            email: '',
            user: undefined,
            showUpdateCubesModal: true
        };
    },
    components: {
        showMap: Map,
        ProductsTable,
        ShopCubes,
        ShopDevices
    },
    props: {
        id: {
            type: String
        },
        showInformationUpdateCubes: false
    },
    computed: {
        ...mapGetters(['getUserId', 'currentSetup'])
    },
    watch: {
        shop (v) {
            if (v) {
                this.qrcode(v, this.setup);
            }
        },
        setup (v) {
            if (v) {
                this.qrcode(this.shop, v);
            }
        }
    },
    beforeDestroy () {
        this.$store.commit('currentShop', {});
    },
    methods: {
        ...mapActions(['GetShopById', 'GetAllUsers', 'AddShopToUser', 'addUserToShop', 'RegisterUser', 'DelUser', 'DelShopFromUser', 'deleteUserFromShop', 'GetSetupDataById' ]),
        qrcode (shop, setup) {
            const canvas2 = this.$refs.new;
            const { installation = {}} = setup;
            const { proxy = undefined } = installation;

            let newqr = {
                setupid: shop.setupID,
                environment: `${process.env.VUE_APP_ENV}`,
                branch: `${process.env.VUE_APP_BRANCH}`,
                proxy: proxy
            }
            QRCode.toCanvas(
                canvas2,
                JSON.stringify(newqr),
                {
                    errorCorrectionLevel: 'H',
                    version: 16
                },
                error => {
                    if (error) {
                        console.error(error);
                    } else {
                        let ctx = canvas2.getContext('2d');
                        ctx.font = '15px serif';
                        ctx.fillText('NEW QR code', 15, 10);
                    }
                }
            );
        },
        showUpdateModal(){
            this.$store.dispatch('informationAction', {information: this.$t('INFORMATIONS.pleaseUpdateCubes'),
                callback: (decision = false) => {
                }
            })
        },
        downloadCode (showBox, shop) {
            const link = this.$refs['downloadLink'];
            const canvas = this.$refs[showBox];
            link.href = canvas.toDataURL('image/png');
            link.download = `${showBox}_${shop.id}_qrCode.png`;
            link.click();
        },
        async loadData (){
            this.shop = await this.GetShopById(this.$props.id);
            this.setup = await this.GetSetupDataById(this.$props.id);
        },
        getShopOwner () {
            (async () => {
                const { data:users } = await this.$axios.get('/auth/user/data');
                this.shopOwnerData = users.find(user =>  user?.context === this.id) || '';
                const { email = '' } = this.shopOwnerData?.contact || '';
                this.email = email;
                this.shopOwner = this.shopOwnerData ? true : false
            })().catch(err => console.log(err));
        },
        validateEmail (email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        async setShopOwner () {
            console.log('setShopOwner')
            if(!this.validateShopOwner()) return;

            if(this.shopOwnerData !== '') {
                this.updataShopOwner().then((data) => {
                    console.log('updataShopOwner', data.data)
                    this.$notify({
                        title: 'Add Shop Owner',
                        message: 'Shop Owner has been updated',
                        type: 'success'
                    });
                }).catch(err => {
                    this.$notify({
                        title: 'Update Shop Owner',
                        message: 'Something went wrong',
                        type: 'error'
                    });
                    console.log(err);
                });
                return;
            }
            await this.addShopOwner().then(() => {
                this.$notify({
                    title: 'Add Shop Owner',
                    message: 'Shop Owner has been added',
                    type: 'success'
                });
            }).catch(err => {
                this.$notify({
                    title: 'Add Shop Owner',
                    message: 'Something went wrong',
                    type: 'error'
                });
                console.log(err);
            });
        },
        async deleteSHopOwner(shopOwner){
            const { id, parent } = shopOwner;
            try {
                await this.DelShopFromUser( { id, shopId: this.id })
                await this.deleteUserFromShop( { shopId: this.id, userId: id })
                await this.DelUser({ id, parent })
                this.getShopOwner();
            } catch (error) {
                this.$notify({
                    title: 'FFailed',
                    message: 'remove shop owner from shop',
                    type: 'error'
                });
            }
        },
        validateShopOwner() {
            if (!this.validateEmail(this.email)) {
                this.$notify({
                    title: 'Email',
                    message: 'Email must be valid',
                    type: 'error'
                });
                return false;
            }
            if (!this.shopOwnerPass) {
                this.$notify({
                    title: 'Password',
                    message: 'Password can\'t be blank',
                    type: 'error'
                });
                return false;
            }
            if (this.shopOwnerPass !== this.shopOwnerPassRepeat) {
                this.$notify({
                    title: 'Password',
                    message: 'Password doesn\'t match',
                    type: 'error'
                });
                return false;
            }
            if (this.shopOwnerPass.length < 5) {
                this.$notify({
                    title: 'Password',
                    message: 'Password is to short',
                    type: 'error'
                });
                return false;
            }
            return true;
        },
        async addShopOwner() {
            const user = {
                'role': {
                    name: 'key_account',
                    displayName: 'Key Account'
                },
                'address': {
                    companyName: '',
                    street: '',
                    streetNumber: '',
                    postCode: '',
                    city: '',
                    country: ''
                },
                'contact': {
                    phone: '',
                    mobilePhone: '',
                    email: this.email
                },
                parentId: this.getUserId,
                context:this.id,
                person: {
                    salutation: '',
                    firstName: '',
                    lastName: ''
                },
                pass: {
                    password: this.shopOwnerPass,
                    repeatPassword: this.shopOwnerPassRepeat
                }
            };
            const newUser = await this.RegisterUser(user).catch(err => console.log(err));
            const newUserId = newUser?.data?.id || '';

            await Vue.axios.put(`/stores/store/${this.id}/user/`,
                [{"id": newUserId}]
            ).catch(err => {
                throw new Error(err);
            });

            await Vue.axios.post(`/auth/user/${newUserId}/shop`,
                { "shop" : this.id}
            ).catch(err => {
                throw new Error(err);
            });
            this.getShopOwner();
            this.shopOwnerPass = '';
            this.shopOwnerPassRepeat = '';
        },
        async updataShopOwner() {
            // await this.$axios()
            const { id = false }  = this.shopOwnerData;

            if(id === false)
            {
                this.$notify({
                    title: 'Update problem',
                    message: 'Something went wrong',
                    type: 'error'
                });
            }
            const data = await Vue.axios.put(`/auth/user/${id}/data`,
                {
                    "contact": {
                        "email": this.email
                    },
                    "pass":{
                        "password":this.shopOwnerPass,
                        "repeatPassword":this.shopOwnerPassRepeat
                    }
                 }
            )
            .catch(err => {
                console.log({error})
                throw new Error(err);
            });

            return data;
        },
        showUpdateModal(){
            this.$store.dispatch('informationAction', {information: this.$t('INFORMATIONS.pleaseUpdateCubes'),
                callback: (decision = false) => {
                }
            })
        }
    },
    mounted () {
        this.getShopOwner ();
        this.loadData();
        this.shopOwner= false;
        this.shopOwnerData= '';
        this.shopOwnerPass = '';
        this.shopOwnerPassRepeat = '';
        this.email = '';
        if(this.$props.showInformationUpdateCubes && this.showUpdateCubesModal){
            this.showUpdateCubesModal = false;
            this.showUpdateModal();
        }
    }
};
</script>

<style lang="scss" scoped>
.map-container {
  height: 150px;
}
img.shopimage {
  height: 100%;
  width: auto;
  align-items: center;
}
.container > div > .row {
  padding-bottom: 10px;
}
.panel {
  height: 100%;
}
.shop-title {
    display: flex;
    align-items: center;
  .image-title {
    border: 1px solid #ebedf2;
    border-radius: 4px;
    padding: 5px;
    height: 60px;
    display: inline-block;
  }
  .text-title {
    display: grid;
    margin-left: 1rem;
    h3 {
      font-size: 1.2rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.qr-box {
  margin: 0 auto;
  align-items: center;
  display: flex;
  justify-content: center;

}

.shopinfo {
  tr {
    display: block;
    width: 100%;
    position: relative;
  }
  tr:first-of-type {
    th,
    td {
      border-top: none;
    }
  }
  tr {
    border-bottom: 1px solid #dee2e6;
    th,
    td {
      border-top: none;
    }
  }
  /*th{
        text-align: right;
      }
      td{
        text-align: left;
      }*/
  th {
    position: absolute;
    top: 2px;
    left: 0;
    font-size: .8em;
  }
  td {
    font-style: italic;
    top: 0.8em;
    font-size: 1em;
    text-align: center;
    display: block;
    padding-bottom: 0.2em;
    padding-top: 0.8em;
    height: auto;
    margin-left: 3.7rem;
    white-space: nowrap;
    width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.passArrow {
    font-size: 25px;
}
.pass-header {
    cursor: pointer;
}

canvas#new {
    width: 100% !important;
    object-fit: contain;
}
.small, small{
    font-size:medium;
    font-weight:400;
}
</style>
